"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CompanyInfoEdit_1 = require("./CompanyInfoEdit");
exports.default = CompanyInfoEdit_1.CompanyInfoEdit;
